import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTarget16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTarget16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.329.767 13.073 0 12.5.572l-1.85 1.85-.189.188.053.263.073.366a5.754 5.754 0 1 0 2.174 2.172l.364.073.263.052.189-.189 1.85-1.849.571-.572-.767-.256-1.428-.475zM11.853 4.21l1.207.241 1.088-1.088-.897-.299-.237-.079-.08-.237-.298-.897-1.088 1.088.241 1.207zm.655 4.038a4.754 4.754 0 1 1-1.764-3.696l-.778.778a3.661 3.661 0 1 0 .707.707l.778-.778a4.73 4.73 0 0 1 1.057 2.989M7.754 5.587c.555 0 1.07.17 1.496.459l-.797.796a1.57 1.57 0 1 0 .707.707l.797-.796a2.661 2.661 0 1 1-2.202-1.166m0 3.23a.57.57 0 1 0 0-1.138.57.57 0 0 0 0 1.138"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTarget16);
